import { CDN_CONFIGURATION } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { ICdnConfigurationRepository } from "features/cdnConfiguration/domain/repositories/ICdnConfigurationRepository";
import { injectable } from "tsyringe";
import { CdnConfigurationFormRequestEntity } from "features/cdnConfiguration/domain/entities/CdnConfigurationFormRequestEntity";
import { CdnConfigurationListRequestModel } from "./model/CdnConfigurationListRequestModel";
import { CdnConfigurationFormRequestModel } from "./model/CdnConfigurationFormRequestModel";
import { CdnConfigurationResponseModel } from "./model/CdnConfigurationResponseModel";

@injectable()
export class CdnConfigurationImpl implements ICdnConfigurationRepository {
  async getList(
    params: CdnConfigurationListRequestModel,
  ): Promise<ListBaseApiResponseModel<CdnConfigurationResponseModel>> {
    return await client?.get(CDN_CONFIGURATION?.LIST, params);
  }

  async uploadFile(
    body: CdnConfigurationFormRequestModel,
  ): Promise<BaseApiResponseModel<CdnConfigurationResponseModel>> {
    const requestBody = body as CdnConfigurationFormRequestEntity;
    const formData = new FormData();
    if (requestBody.name) formData.append("name", requestBody.name);
    if (requestBody.code) formData.append("code", requestBody.code);
    if (requestBody.type) formData.append("type", requestBody.type);
    if (requestBody.description) formData.append("description", requestBody.description);
    if (requestBody.file) formData.append("file", requestBody.file);

    return await client?.post(CDN_CONFIGURATION?.UPLOAD, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async deleteFile(params: {
    code: string;
  }): Promise<BaseApiResponseModel<CdnConfigurationResponseModel>> {
    return await client?.delete(CDN_CONFIGURATION?.DELETE, params);
  }
}
